import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("looxs_bag") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("looxs_bag", JSON.stringify(items)); }, [items]);

  const addGiftCard = (amount, label) => {
    setItems((prev) => {
      const idx = prev.findIndex(i => i.kind === "gift_card" && i.gift_amount === amount);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + 1 };
        return next;
      }
      return [...prev, { kind: "gift_card", gift_amount: amount, name: `LOOXS Gift Card ${label}`, price: amount, quantity: 1 }];
    });
    setOpen(true);
  };

  const setQty = (index, q) => {
    setItems(prev => prev.map((it, i) => i === index ? { ...it, quantity: Math.max(1, q) } : it));
  };
  const remove = (index) => setItems(prev => prev.filter((_, i) => i !== index));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  const value = useMemo(
    () => ({ items, addGiftCard, setQty, remove, clear, subtotal, count, open, setOpen }),
    [items, subtotal, count, open]
  );

  return (
    <CartCtx.Provider value={value}>
      {children}
    </CartCtx.Provider>
  );
}
export const useCart = () => useContext(CartCtx);
